import React from "react";
import { Button } from "antd";
import { Modal } from "antd";
import { PropTypes } from "prop-types";
import style from "./style.module.scss";
import ReactHtmlParser from "react-html-parser";
import "./style.scss";

var languageFile = require("../../../public/languages/Translation");
let _ = require("lodash");

/**
 *
 * Modal Form to show the  popup with  Descriptions to explain what the form does.
 *
 */
export const ModalForm = (props) => {
	return (
		<Modal
			wrapClassName="model-window"
			onCancel={props.onCancel}
			width={props.width}
			footer={null}
			centered
			visible={props.visible}>
			{rendermodalForm(props)}
		</Modal>
	);
};

const rendermodalForm = (props) => {
	return (
		<div className={style.modalForm}>
			<div className={style.groupContent}>
				<h2> {props.header}</h2>
				{props.label && <p>{props.label}</p>}
				{props.children}
				{props.enableButton && (
					<div className={style.button}>
						<Button onClick={props.onCancel} className="secondary-btn">
							{languageFile[localStorage.getItem('language')]['10523']}
						</Button>
						<Button onClick={props.onSubmit} className="primary-btn">
							{props.buttonLabel}
						</Button>
					</div>
				)}
			</div>
			<div className={style.descriptionBlock}>
				<span className={style.cercleShapeone}>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 341 441.502">
						<path
							id="Path_211"
							data-name="Path 211"
							d="M-2427,442.5h0V296.969a271.6,271.6,0,0,0,32.571-11.383,272.528,272.528,0,0,0,46.287-25.124,274.4,274.4,0,0,0,40.329-33.275,274.39,274.39,0,0,0,33.275-40.33,272.566,272.566,0,0,0,25.125-46.288,271.084,271.084,0,0,0,15.878-51.151A274.47,274.47,0,0,0-2228,34.5,276.577,276.577,0,0,0-2230.042,1h142.707c.886,11.1,1.335,22.375,1.335,33.5a421.074,421.074,0,0,1-2.14,42.38,415.471,415.471,0,0,1-6.281,41.156c-2.734,13.359-6.17,26.724-10.214,39.723-3.994,12.846-8.684,25.659-13.938,38.083a414.536,414.536,0,0,1-38.217,70.409A417.345,417.345,0,0,1-2207.4,327.6a417.426,417.426,0,0,1-61.344,50.613,414.567,414.567,0,0,1-70.409,38.217c-12.418,5.252-25.231,9.941-38.083,13.938-13.006,4.046-26.371,7.482-39.723,10.214C-2420.276,441.256-2423.653,441.9-2427,442.5Z"
							transform="translate(2427 -1)"
						/>
					</svg>
				</span>
				<span className={style.cercleShapetwo}>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 341 441.502">
						<path
							id="Path_212"
							data-name="Path 212"
							d="M-2086,1h0V146.533a271.6,271.6,0,0,0-32.571,11.383,272.528,272.528,0,0,0-46.287,25.124,274.4,274.4,0,0,0-40.329,33.275,274.391,274.391,0,0,0-33.275,40.33,272.567,272.567,0,0,0-25.125,46.288,271.085,271.085,0,0,0-15.878,51.151A274.47,274.47,0,0,0-2285,409a276.577,276.577,0,0,0,2.043,33.5h-142.707c-.886-11.1-1.335-22.375-1.335-33.5a421.074,421.074,0,0,1,2.14-42.38,415.469,415.469,0,0,1,6.281-41.156c2.734-13.359,6.17-26.724,10.214-39.723,3.994-12.846,8.684-25.659,13.938-38.083a414.536,414.536,0,0,1,38.217-70.409,417.347,417.347,0,0,1,50.614-61.345,417.426,417.426,0,0,1,61.344-50.613,414.567,414.567,0,0,1,70.409-38.217c12.418-5.252,25.231-9.941,38.083-13.938,13.006-4.046,26.371-7.482,39.723-10.214C-2092.724,2.246-2089.348,1.6-2086,1Z"
							transform="translate(2427 -1)"
						/>
					</svg>
				</span>
				<span className={style.rectangleShape}>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 205 184">
						<path
							id="Path_223"
							data-name="Path 223"
							d="M-2597-272v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm200-20v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm200-20v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm200-20v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm200-20v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm200-19v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm200-20v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm200-20v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm200-20v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm200-20v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Zm-20,0v-5h5v5Z"
							transform="translate(2797 456)"
						/>
					</svg>
				</span>
				<div className={style.descriptionContent}>
					<ul className={style.contentList}>
						{_.map(props.description, (item, key) => {
							return (
								<li key={key}>
									{item.split(' \n').map((i, idx) => (
										!props.renderHTML ? <p key={idx}>{i}</p> : <React.Fragment key={idx}>{ReactHtmlParser(i)}</React.Fragment>
									))}
								</li>
							)
						})}
					</ul>
				</div>
			</div>
		</div>
	)
}

ModalForm.propTypes = {
	/**
	 * main header text
	 */
	header: PropTypes.string,
	/**
	 * sub-header text
	 */
	label: PropTypes.string,
	/**
	 * right-side section description
	 */
	description: PropTypes.arrayOf(PropTypes.string),
	/**
	 * submit and close button --> is hidden or visible
	 */
	enableButton: PropTypes.bool,
	/**
	 * width of the popup model
	 */
	width: PropTypes.number,
	/**
	 * to show the popup model
	 */
	visible: PropTypes.bool,
	/**
	 * to render html string
	 */
	renderHTML: PropTypes.bool
};

ModalForm.defaultProps = {
	className: '',
	header: '',
	label: '',
	enableButton: false,
	width: 800,
	description: [],
	visible: true,
	renderHTML: false
};
